const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
const apiKey = process.env.NEXT_PUBLIC_API_KEY;

export const LoginApi = async (url, formData) => {
    const response = await fetch(baseURL + url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        headers: {
            Connection: "keep-alive",
            "Content-Type": "application/json",
            "x-api-key": apiKey,
        },
        body: JSON.stringify(formData), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
};

export const PostData = async (url = "admin", token, formData) => {
    const headers = {
        "Content-Type": "application/json",
        "x-api-key": apiKey,
    };

    if (token) {
        headers.Authorization = token;
    }

    const response = await fetch(baseURL + url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        headers: headers,
        body: JSON.stringify(formData), // body data type must match "Content-Type" header
    });

    if (response.status === 401) {
        return response;
    } else {
        return response.json();
    }
};

export const fetchUsers = async (token, query, searchBy, limit, nextToken) => {
    const payload = {
        operation: "userSearch",
        query: query,
        searchBy: searchBy,
        limit: limit,
    };

    if (nextToken) {
        payload.nextToken = nextToken;
    }

    const response = await PostData("admin", token, payload);
    return response.data;
};

export const fetchUserSummary = async (token) => {
    const payload = {
        operation: "usersSummary",
    };

    const response = await PostData("admin", token, payload);
    return response.data;
};

export const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const getLatestUserDetails = async (setUserResultDispatch, token, apiPayload) => {
    const response = await PostData("admin", token, apiPayload);
    if (response.status === 401) {
        const loggedOutTimeout = () => {
            setTimeout(() => {
                window.location.href = "/";
            }, 4000);
        };

        loggedOutTimeout();
        clearTimeout(loggedOutTimeout);

        return false;
    }

    if (response.message) {
        const loggedOutTimeout = () => {
            setTimeout(() => {}, 4000);
        };

        loggedOutTimeout();
        clearTimeout(loggedOutTimeout);

        return false;
    }

    // Catch when users array doesn't exist
    if (response.data.users.length <= 0) {
        const loggedOutTimeout = () => {
            setTimeout(() => {}, 4000);
        };

        loggedOutTimeout();
        clearTimeout(loggedOutTimeout);

        return false;
    }

    if (response.data.users.length > 0) {
        setUserResultDispatch({
            didUpdateInitialCredentials: response.data.users[0].didUpdateInitialCredentials,
            email: response.data.users[0].email,
            id: response.data.users[0].id,
            username: response.data.users[0].username,
            phoneNumber: response.data.users[0].phoneNumber,
            tempAuthCode: response.data.users[0].tempAuthCode,
            appleTransactions: response.data.users[0].userData.appleTransactions,
            deviceTokens: response.data.users[0].userData.deviceTokens,
            fulfilledPromotions: response.data.users[0].userData.fulfilledPromotions,
            gender: response.data.users[0].userData.gender,
            genderPref: response.data.users[0].userData.genderPref,
            isEnabled: response.data.users[0].isEnabled,
            isAdmin: response.data.users[0].isAdmin,
            isOptedIntoMarketingEmails: response.data.users[0].userData.isOptedIntoMarketingEmails,
            language: response.data.users[0].userData.language,
            seconds: response.data.users[0].userData.seconds,
            minutes: response.data.users[0].userData.minutes,
            totalFreeMinutes: response.data.users[0].userData.totalFreeMinutes,
            totalMinutesBought: response.data.users[0].userData.totalMinutesBought,
            totalSpent: response.data.users[0].userData.totalSpent,
            transactions: response.data.users[0].userData.transactions,
            type: response.data.users[0].userData.type,
            totalPaidAmount: response.data.users[0].userData.transactionMetrics.totalPaidAmount,
            totalPaidSeconds: response.data.users[0].userData.transactionMetrics.totalPaidSeconds,
            totalFreeSeconds: response.data.users[0].userData.transactionMetrics.totalFreeSeconds,
            totalSecondsUsed: response.data.users[0].userData.transactionMetrics.totalSecondsUsed,
            avgSecondsUsedPerMonth: response.data.users[0].userData.transactionMetrics.avgSecondsUsedPerMonth,
            totalRemainingSeconds: response.data.users[0].userData.transactionMetrics.totalRemainingSeconds,
            subscription: response.data.users[0].userData.subscription,
        });
    }
};

export const addPromoCode = async (token, promoData) => {
    const payload = {
        operation: "addPromotion",
        promoCode: promoData.promoCode,
        startDate: promoData.startDate,
        endDate: promoData.endDate,
        minutes: promoData.minutes,
        usesPerUser: promoData.usesPerUser,
        totalUses: promoData.totalUses,
        creator: promoData.creator,
    };

    const response = await PostData("admin", token, payload);
    return response;
};

export const removePromoCode = async (token, promoCode) => {
    const payload = {
        operation: "removePromotion",
        promoCode: promoCode,
    };

    const response = await PostData("admin", token, payload);
    return response;
};

export const fetchPromoCodes = async (token) => {
    const payload = {
        operation: "fetchPromotions",
    };

    const response = await PostData("promoVerifier", token, payload);
    return response;
};

export const fetchMatches = async (token) => {
    const payload = {
        operation: "fetchAllMatches",
    };

    const response = await PostData("handleMatches", token, payload);
    return response;
};

export const fetchActives = async (token) => {
    const payload = {
        operation: "fetchAllActives",
    };

    const response = await PostData("handleMatches", token, payload);
    return response;
};

export const clearMatchesAndActives = async (token) => {
    const payload = {
        operation: "removeMatchesAndActives",
    };

    const response = await PostData("handleMatches", token, payload);
    return response;
};

export const clearSelectedMatches = async (token, phoneNumbers) => {
    const payload = {
        operation: "clearMatches",
        phoneNumbers: phoneNumbers,
    };

    const response = await PostData("handleMatches", token, payload);
    return response;
};

export const clearSelectedActives = async (token, phoneNumbers) => {
    const payload = {
        operation: "clearActives",
        phoneNumbers: phoneNumbers,
    };

    const response = await PostData("handleMatches", token, payload);
    return response;
};

export const fetchPromoTransactions = async (token, userId, startDate, endDate, sort = "desc") => {
    const payload = {
        operation: "fetchTransactions",
        sort: sort,
        types: ["promotions"],
    };

    if (userId) {
        payload.userID = userId;
    }

    if (startDate) {
        payload.startDate = startDate;
    }

    if (endDate) {
        payload.endDate = endDate;
    }

    const response = await PostData("admin", token, payload);
    return response;
};

export const fetchRevenueCatLogs = async (token, params = {}) => {
    const payload = {
        operation: "revenueCatLogs",
        limit: params.limit || 25,
        offset: params.offset || 0,
    };

    if (params.eventType) {
        payload.eventType = params.eventType;
    }

    const response = await PostData("admin", token, payload);
    return response;
};
